/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_ToInputs */

const cs_calendar_sync_to = /** @type {(inputs: Calendar_Sync_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizovat s Google / Outlook`)
};

const en_calendar_sync_to = /** @type {(inputs: Calendar_Sync_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync to Google / Outlook`)
};

/**
* | output |
* | --- |
* | "Sync to Google / Outlook" |
*
* @param {Calendar_Sync_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_to = /** @type {((inputs?: Calendar_Sync_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_to(inputs)
	return cs_calendar_sync_to(inputs)
});